// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1Xt6Z","action":"styles_action__3CKiW","footer":"styles_footer__3BMTO","content":"styles_content__kXwi3","fields":"styles_fields__2K4kf"};